import React, { useState, createContext } from "react";

export const WholesaleInvsContext = createContext();

const WholeSaleInvsProvider = ({ children }) => {
	const [inventoryID, editInventoryID] = useState(null);
	const [bulkVehicle, editBulkVehicle] = useState({});
	const [dealId, editdealId] = useState();
	const [salesPrice, editSalesPrice] = useState();
	const [modalActive, setModalActive] = useState(false);
	const toggleWholesaleInvsModal = () => setModalActive(!modalActive);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isLoading, editIsLoading] = useState(false);
	const [bulkVehicles, setBulkVehicles] = useState([]);

	// Add vehicle if not already in list
	const addBulkVehicle = (vehicle) => {
		setBulkVehicles((prev) => {
			const exists = prev.some((v) => v.inventoryID === vehicle.inventoryID);
			if (exists) return prev; // don't duplicate
			return [...prev, vehicle];
		});
	};

	// Remove vehicle by inventoryID
	const removeBulkVehicle = (inventoryID) => {
		setBulkVehicles((prev) =>
			prev.filter((v) => v.inventoryID !== inventoryID)
		);
	};

	const context = {
		inventoryID,
		editInventoryID,
		bulkVehicle,
		editBulkVehicle,
		dealId,
		editdealId,
		salesPrice,
		editSalesPrice,
		modalActive,
		setModalActive,
		toggleWholesaleInvsModal,
		currentIndex,
		setCurrentIndex,
		isLoading,
		editIsLoading,
		bulkVehicles,
		setBulkVehicles,
		addBulkVehicle,
		removeBulkVehicle,
	};
	return (
		<WholesaleInvsContext.Provider value={context}>
			{children}
		</WholesaleInvsContext.Provider>
	);
};

export default WholeSaleInvsProvider;
